import React, { ReactElement, SVGProps } from 'react';

const WYPButtonIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.78733 4.74854L12.4121 0.123812C12.4594 0.0764719 12.4266 0 12.3611 0H0.635389C0.569842 0 0.537068 0.0801134 0.584408 0.123812L5.2055 4.7449C5.91559 5.455 7.07724 5.455 7.78733 4.7449"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59208 5.78986L12.412 1.96991H12.4157C12.4594 1.92257 12.5395 1.95534 12.5395 2.02089V17.0276C12.5395 17.5665 12.1025 17.9999 11.5672 17.9999H1.43286C0.893912 17.9999 0.460571 17.5629 0.460571 17.0276V2.02089C0.460571 1.95534 0.537043 1.92257 0.584383 1.96991L4.4189 5.78986C5.56962 6.94058 7.44136 6.94058 8.59208 5.78986ZM9.42234 12.6543L9.51338 12.5633C10.2781 11.8022 10.4019 10.5641 9.71367 9.73016C8.9271 8.77608 7.51055 8.7251 6.65479 9.58086L6.4982 9.73744L6.34162 9.58086C5.48586 8.7251 4.06931 8.77608 3.28274 9.73016C2.5945 10.5604 2.71831 11.7985 3.48303 12.5633L3.57406 12.6543C3.57406 12.6543 6.18503 14.8174 6.4982 15.5784C6.81138 14.8174 9.42234 12.6543 9.42234 12.6543Z"
        fill="white"
      />
    </svg>
  );
};

export default WYPButtonIcon;
